import debounce from './debounce'
import waitAll from './waitAll'
import waitFor from './waitFor'
import waitTimeout from './waitTimeout'

export default { debounce, waitAll, waitFor, waitTimeout }
